/** VERSION: 1.0.0 Please do not delete this line. Thank you! **/
// Override Settings

var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
      suggestionMobileStyle: "style2",
      showSearchBtnMobile: false
	}
};


if (boostPFSConfig?.settings?.search?.suggestionBlocks && window.innerWidth > 749) {

  let productType = boostPFSConfig?.settings?.search?.suggestionBlocks.find(block => block.type === 'products');

  if (productType) {
    productType.number = productType.number + 2;

    boostPFSInstantSearchConfig.search.suggestionBlocks = boostPFSConfig?.settings?.search?.suggestionBlocks
  }
}

(function() {
	BoostPFS.inject(this);


  // Clear button for the Form Search
  HTMLDocument.prototype.ready = function () {
    return new Promise(function(resolve, reject) {
      if (document.readyState === 'complete') {
        resolve(document);
      } else {
        document.addEventListener('DOMContentLoaded', function() {
          resolve(document);
        });
      }
    });
  }


  var privateMethod_maxHeight = InstantSearchResult.prototype._maxHeight;

  InstantSearchResult.prototype._maxHeight = function () {
    return privateMethod_maxHeight.call(this) + 30;
  }


  document.ready().then(function(){
    var inputSearchFormSelector = jQ('.boost-pfs-search-input');
    var clearSearchFormSelector = jQ('.boost-pfs-search-form-btn-clear');

    if(!!inputSearchFormSelector.val()) {
      clearSearchFormSelector.show();
    }

    inputSearchFormSelector.on('change keydown keyup', function(){
      if(!!jQ(this).val()) {
        clearSearchFormSelector.show();
      } else {
        clearSearchFormSelector.hide();
      }
    })

    clearSearchFormSelector.on("click", function(){
      inputSearchFormSelector.val("");
      jQ(this).hide();
      inputSearchFormSelector.click();
    });
  })// End Clear button for the Form Search


	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};

  // Bind Event for input search Mobile
  var bindEventsMobile = InstantSearchMobile.prototype.bindEvents;
  InstantSearchMobile.prototype.bindEvents = function() {
    bindEventsMobile.call(this);

    var self = this;
    var searchButtonMobile = '.site-nav--mobile .search-button, .js-search-destop';
    var searchInputMobile = '.search-input-group input[type="search"], .wg-search-form .search-input';
    var searchCloseButtonMobile = '.drawer__close > button, .drawer_back a';
    jQ(searchButtonMobile).off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ(searchInputMobile).focus();
      self.openSuggestionMobile();
      jQ(searchCloseButtonMobile).trigger('click');

    });
  }

  // Bind Event for input search style 3
  var bindEvents = InstantSearchStyle3.prototype.bindEvents;
  InstantSearchStyle3.prototype.bindEvents = function() {
    bindEvents.call(this);

    var self = this;
    var searchButtonDesktop = '.site-header__links .search-button';
    var searchInputDesktop = '#SearchContainer #search-input';
    var searchCloseButtonDesktop = '.drawer__close > button';
    jQ(searchButtonDesktop).off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ(searchInputDesktop).focus();
      self.openSuggestionStyle3();
      jQ(searchCloseButtonDesktop).trigger('click');

    });
  }

  InstantSearchResultItemProduct.prototype.afterRender = function () {
    if (this.data && this.data.price_min == 0) {
      this.$element.addClass('hidden-price');
    }

    // Only keep the slash/compare price when the displayed (lowest-price) variant
    // is itself on sale. The vendor renders the slash whenever
    // compare_at_price_min > price_min, which can be true across two different
    // variants and slash a variant that is not actually on sale.
    var variants = this.data && this.data.variants;
    if (variants && variants.length) {
      var lowest = null;
      for (var i = 0; i < variants.length; i++) {
        var p = Number(variants[i].price);
        if (lowest === null || p < Number(lowest.price)) lowest = variants[i];
      }
      var compare = lowest ? Number(lowest.compare_at_price) : 0;
      var lowestOnSale = compare > Number(lowest.price) && compare > 0;
      if (!lowestOnSale) {
        var $price = this.$element.find('.boost-pfs-search-suggestion-product-price');
        $price.find('s').remove();
        $price
          .find('.boost-pfs-search-suggestion-product-sale-price')
          .removeClass('boost-pfs-search-suggestion-product-sale-price')
          .addClass('boost-pfs-search-suggestion-product-regular-price');
      }
    }
  }

  // Fix search for the Flow theme
  jQ('.site-header__links .search-button').on('click', function() {
    setTimeout(function() {
      boostPFS.initSearchBox();
      if(Utils.isCollectionPage()) jQ('.search-input-group > .boost-pfs-search-box').val('');
    }, 500);
  });

})();
